import { render } from "./VUEAppMenu.vue?vue&type=template&id=245be63a&scoped=true"
import script from "./VUEAppMenu.vue?vue&type=script&lang=js"
export * from "./VUEAppMenu.vue?vue&type=script&lang=js"

import "./VUEAppMenu.vue?vue&type=style&index=0&id=245be63a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-245be63a"]])

export default __exports__